import React from 'react';
import { useSession } from '_effects/useSession';

const SessionInitializer: React.FC = (): null => {
  useSession();
  return null;
};

export default SessionInitializer;